// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2uCH3","text":"SelectPayment_text__2u1-k","title":"SelectPayment_title__1oHRn","btn":"SelectPayment_btn__1l7zW"};